export const aboutRoutePrefix = 'about';
